// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-44448ea4]{display:flex;flex-direction:row;align-items:center;margin:1rem 0}.page .pageitem[data-v-44448ea4]{box-sizing:border-box;height:2.4em;min-width:2.4em;padding:.6em;line-height:1;border-radius:3px;border:1px solid #d8d8d8;text-align:center;margin:.25em;cursor:default}.page .pageitem.active[data-v-44448ea4]{border-color:#00a0ea;background-color:#00a0ea;color:#fff}", ""]);
// Exports
module.exports = exports;
